(function () {
  'use strict';

  angular
    .module('FeatureFlagModule')
    .constant('FeatureHubConfigKeys', {
      MEASUREMENT_SYSTEM: 'PSVI_748_MEASUREMENT_SYSTEM'
    });
}());
